window.pluralize = (word, count) => {
  let normalized = word
    .replace(/-table$/, '')
    .replace(/-/g, ' ');

  const base = normalized.endsWith('s')
      ? normalized.slice(0, -1)
      : normalized;

  return count <= 1 ? base : `${base}s`;
};
